<template>
  <div>
    <div id="Overview" class="overview-area">
      <div class="container-fluid">
        <div class="row align-items-center">
          <div class="col-lg-12 col-md-12">
            <div class="overview-content text-center">
              <img
                class="margin-tops"
                src="../assets/img/logo.png"
                height="150"
                alt="logo"
              />
              <br /><br /><br />
              <p>
                PlayCourt is a comprehensive application development platform
                <br />
                specifically designed for the development of Telkom Indonesia's
                digital products.
              </p>
              <br />
              <ul class="overview-btn">
                <li>
                  <a
                    href="https://dashboard.playcourt.id/login"
                    class="main-default-btn"
                    >Order Now</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <cookie-consent
      position="bottom-left"
      :forceHide="hideCookieConsent"
      @accepted="cookieAccepted"
      @declined="cookieDeclined"
      @customize="openCookieSettings"
    />
    <cookie-settings
      :show="showCookieSettings"
      @close="closeCookieSettings"
      @save="saveCookiePreferences"
    />
  </div>
</template>

<script>
import CookieConsent from "@/components/CookieConsent.vue";
import CookieSettings from "@/components/CookieSettings.vue";

// Define constants for cookie keys
const COOKIE_CONSENT_KEY = "cookie-consent";

export default {
  name: "AppOverview",
  components: {
    CookieConsent,
    CookieSettings,
  },
  data() {
    return {
      showCookieSettings: false,
      hideCookieConsent: false,
      cookiePreferences: {
        authentication: true,
      },
    };
  },
  mounted() {
    // Load saved preference based on cookie-consent value
    const consentStatus = this.$cookies.get(COOKIE_CONSENT_KEY);

    // If consent status exists, set preferences accordingly
    if (consentStatus) {
      this.cookiePreferences = {
        authentication: consentStatus === "accepted",
      };
      console.log("Loaded saved cookie preference:", this.cookiePreferences);
    }
  },
  methods: {
    cookieAccepted() {
      const isLocalhost =
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1";

      console.log("Cookies accepted");

      this.$cookies.set(
        COOKIE_CONSENT_KEY,
        "accepted",
        "365d",
        "/",
        isLocalhost ? "" : ".playcourt.id",
        true,
        "Lax"
      );
    },
    cookieDeclined() {
      const isLocalhost =
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1";
      console.log("Cookies declined");
      this.$cookies.set(
        COOKIE_CONSENT_KEY,
        "declined",
        "365d",
        "/",
        isLocalhost ? "" : ".playcourt.id",
        true,
        "Lax"
      );
    },
    openCookieSettings() {
      console.log("Open cookie settings");
      this.showCookieSettings = true;
    },
    closeCookieSettings() {
      this.showCookieSettings = false;
    },
    saveCookiePreferences(preferences) {
      console.log("Saving cookie preferences:", preferences);
      this.cookiePreferences = preferences;

      const isLocalhost =
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1";

      // Determine status based on authentication preference
      const consentStatus = preferences.authentication
        ? "accepted"
        : "declined";

      // Only set the cookie-consent cookie
      this.$cookies.set(
        COOKIE_CONSENT_KEY,
        consentStatus,
        "365d",
        "/",
        isLocalhost ? "" : ".playcourt.id",
        true,
        "Lax"
      );

      // Apply cookie preferences
      this.applyCookiePreferences();
      this.hideCookieConsent = true;
    },
    applyCookiePreferences() {
      // Here you would implement the actual cookie management based on preferences
      if (this.cookiePreferences.authentication) {
        console.log("Enabling authentication cookies");
        // Enable authentication cookies
      } else {
        console.log("Disabling authentication cookies");
        // Disable authentication cookies
      }
    },
  },
};
</script>

<style>
.margin-tops {
  margin-top: 60px;
}
</style>
